/**
 * NotificationActionType
 */
export enum NotificationActionType {
    CALENDAR_EVENT_CONFIRMATION = 'calendar-event-confirmation'
}
